import { render, staticRenderFns } from "./group_list_item_actions.vue?vue&type=template&id=50a7162a&vue3"
import script from "./group_list_item_actions.vue?vue&type=script&lang=js&vue3"
export * from "./group_list_item_actions.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports